import { GlobalFooter } from "@/patterns/global-footer/src/index";
import StickyContainer from "@/patterns/sticky-container/sticky-container";
import { FeatureExposed } from "@/utils/feature-exposed";
import { ParentScrollTracking } from "@/utils/scroll-tracking";

import { JiraSitesProvider } from "./jira-sites-provider/jira-sites-provider.tsx";
import { LoggedInHeroSection } from "./logged-in-hero";
import SoftwareJiraLoggedInNavbar from "./logged-in-nav/software-jira-logged-in-navbar.tsx";

export const OrganicD1to6LoggedInJiraProductTourOverview = ({
    experimentValue
}: {
    experimentValue: string;
}) => {
    return experimentValue === "jfind-1506-after-d7-gubtp-organic" ? (
        <JiraSitesProvider>
            <StickyContainer>
                <SoftwareJiraLoggedInNavbar />
            </StickyContainer>
            <ParentScrollTracking scrollTrackingEnabled={true} pageId="jsw">
                <LoggedInHeroSection experimentValue={experimentValue} />
                <GlobalFooter />
            </ParentScrollTracking>
        </JiraSitesProvider>
    ) : (
        <FeatureExposed
            experimentKey="jfind-organic-jpt-logged-in-redesign"
            group="jfind-organic-jpt-logged-in-redesign"
        >
            <JiraSitesProvider>
                <StickyContainer>
                    <SoftwareJiraLoggedInNavbar />
                </StickyContainer>
                <ParentScrollTracking scrollTrackingEnabled={true} pageId="jsw">
                    <LoggedInHeroSection experimentValue={experimentValue} />
                    <GlobalFooter />
                </ParentScrollTracking>
            </JiraSitesProvider>
        </FeatureExposed>
    );
};
